import { createTheme } from '@mui/material';
import { themeOptions } from './DarkTheme'

export const theme = createTheme(themeOptions);